import { Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  setIsSidebarOpen,
  setLevel,
  setSummaryInfoData,
} from "context/features/dataSlice";
import { setIsSourceSidebarOpen } from "context/features/dataSlice";
import CategoryNews from "features/CategoryNews";
import BookmarkDrawer from "features/Bookmarks";
import SourceSidebar from "features/SourceInfo";
import PeerReviewMessageModal from "features/CategoryNews/component/popup/PeerReviewMessageModal";
import BoclipsPlayerDialog from "features/News/components/boclips-player";
import { useSourceSearch } from "features/SourceSearch";
import {
  sources as sourceOptions,
  getCategories,
  biasCategories,
  publishersArray,
  academicSources,
} from "features/SourceSearch/data/search-fields.data";
import { Helmet } from "react-helmet-async";

const NewsCategoryPage = () => {
  const { isSidebarOpen, isSourceSidebarOpen, boclipsPopup } = useSelector(
    (state) => state.data
  );
  const { isHomeschool } = useSelector((state) => state.account);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const {
    search: searchParam,
    source: sourceParam,
    category,
    academiaSearch,
  } = useParams();
  const { currentSearchTerm, sourceCategories } = useSourceSearch();
  const categoryOptions = getCategories(isHomeschool);
  const sidebarClosedHandler = () => {
    dispatch(setIsSidebarOpen(false));
    dispatch(
      setSummaryInfoData({
        publisher: "",
        title: "",
        published_date: "",
        url: "",
        utc_date_published: "",
      })
    );
    setLevel("");
    document.body.style.overflow = "unset";
  };

  const sourceSidebarClosedHandler = () => {
    dispatch(setIsSourceSidebarOpen(false));
    document.body.style.overflow = "unset";
  };

  const showSidebar = () => {
    dispatch(setIsSidebarOpen(true));

    if (typeof window != "undefined" && window.document) {
      document.body.style.overflow = "hidden";
    }
  };

  const showSourceSidebar = () => {
    dispatch(setIsSourceSidebarOpen(true));

    if (typeof window != "undefined" && window.document) {
      document.body.style.overflow = "hidden";
    }
  };

  useEffect(() => {
    const validSourceKeys = sourceOptions.map((item) => item.key);
    const normalizedSource = sourceParam ?? null;

    let fallbackQuery = currentSearchTerm ?? null;
    if (fallbackQuery == null) {
      if (
        normalizedSource != null &&
        !validSourceKeys.includes(normalizedSource)
      ) {
        fallbackQuery = normalizedSource;
      } else if (searchParam != null) {
        fallbackQuery = searchParam;
      }
    }
    const basePath =
      fallbackQuery != null && fallbackQuery !== ""
        ? `/search/${encodeURIComponent(fallbackQuery)}`
        : "/search";

    if (
      normalizedSource != null &&
      !validSourceKeys.includes(normalizedSource)
    ) {
      const destination = `${basePath}${location.search}`;
      navigate(destination, { replace: true });
      return;
    }

    if (normalizedSource === "partner-publishers" && !category) {
      navigate(`${basePath}/partner-publishers${location.search}`, {
        replace: true,
      });
      return;
    }

    if (!category) return;

    const sourceLabels = {
      categories: categoryOptions.map((item) => item.label),
      rating: biasCategories.map((item) => item.label),
      "partner-publishers": publishersArray.map((item) => item.label),
    }[normalizedSource];

    if (sourceLabels == null) return;

    const categoryMatches = sourceLabels.includes(category);
    if (!categoryMatches) {
      if (normalizedSource === "partner-publishers") {
        navigate(`${basePath}/partner-publishers${location.search}`, {
          replace: true,
        });
      } else {
        navigate(`${basePath}${location.search}`, { replace: true });
      }
      return;
    }

    if (
      normalizedSource === "categories" &&
      category === "Academia & Scholarly Resources"
    ) {
      if (!academiaSearch) return;
      const isValidAcademia = academicSources.some(
        (item) => item.label === academiaSearch
      );
      if (!isValidAcademia) {
        navigate(`${basePath}${location.search}`, { replace: true });
      }
    }
  }, [
    academiaSearch,
    category,
    currentSearchTerm,
    location.search,
    navigate,
    searchParam,
    sourceCategories,
    sourceParam,
  ]);

  return (
    <Fragment>
      <Helmet>
        <title>
          Sooth - Search for '{currentSearchTerm}'
        </title>
      </Helmet>

      {/* <SearchLayout> */}
      <CategoryNews />
      <PeerReviewMessageModal />
      {/* </SearchLayout> */}
      <BookmarkDrawer
        isSidebarOpen={isSidebarOpen}
        sidebarClosedHandler={sidebarClosedHandler}
        showSidebar={showSidebar}
      />
      <SourceSidebar
        isSourceSidebarOpen={isSourceSidebarOpen}
        sourceSidebarClosedHandler={sourceSidebarClosedHandler}
        showSourceSidebar={showSourceSidebar}
      />
      {boclipsPopup && <BoclipsPlayerDialog />}
    </Fragment>
  );
};

export default NewsCategoryPage;
